export class WyslijKodWeryfikacyjnyPonownieModel {
    email: string;
}